import { createStrictContext } from 'utils/createContext'
import { ExternalLinkEditorProps } from '../types'
import { FormListOperation } from 'antd/lib/form/FormList'

type Context = ExternalLinkEditorProps & FormListOperation
const { Provider, useContextFn } = createStrictContext<Context>(
  'ExternalLinkEditorContext'
)

/** @private */
export const useExternalLinkEditorContext = useContextFn

/**
 * automatically added to the {@link ExternalLinkEditor}
 * @private
 */
const ExternalLinkEditorProvider: React.FC<Context> = ({
  children,
  ...rest
}) => {
  return <Provider value={rest}>{children}</Provider>
}

export default ExternalLinkEditorProvider
